import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-weekday-assignment-form/configuration-automation-personnel-entities-association-modal-weekday-assignment-form.model'
import { CommonWeekdayEnumResponse } from '@/api/services/common/weekdays/common-weekdays.dto'
import { commonWeekdaysService } from '@/api/services/common/weekdays/common-weekdays.service'
import {
    ConfigurationPersonnelWeekdayAssignmentCreateRequest,
    ConfigurationPersonnelWeekdayAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-weekday-assignment/configuration-personnel-weekday-assignment.dto'
import { configurationPersonnelWeekdayAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-weekday-assignment/configuration-personnel-weekday-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState()
    }

    private async _loadWeekdays(): Promise<void> {
        this.state.weekdays = await this._getWeekdays()
    }

    private async _loadPersonnelWeekdayAssignments(): Promise<void> {
        this.state.personnelWeekdayAssignments = await this._getPersonnelWeekdayAssignments()
    }

    async mounted() {
        await this._loadWeekdays()
        await this._loadPersonnelWeekdayAssignments()
    }

    /// SERVICES CALLS ///

    private async _getWeekdays(): Promise<CommonWeekdayEnumResponse[]> {
        const response = await this.$_toCallUnique(commonWeekdaysService.getWeekdays())
        if (response) {
            return response
        }
        return []
    }

    private async _getPersonnelWeekdayAssignments(): Promise<ConfigurationPersonnelWeekdayAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelWeekdayAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelWeekdayAssignment(createRequest: ConfigurationPersonnelWeekdayAssignmentCreateRequest): Promise<ConfigurationPersonnelWeekdayAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelWeekdayAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deletePersonnelWeekdayAssignment(personnelWeekdayAssignmentId: number): Promise<void> {
        if (personnelWeekdayAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelWeekdayAssignmentService.delete(personnelWeekdayAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(weekday: CommonWeekdayEnumResponse): Promise<void> {
        if (weekday) {
            const createRequest: ConfigurationPersonnelWeekdayAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                weekday: weekday.code
            }
            if (await this._createPersonnelWeekdayAssignment(createRequest)) {
                await this._loadPersonnelWeekdayAssignments()
            }
        }
    }

    async deleteOperation(personnelWeekdayAssignment: ConfigurationPersonnelWeekdayAssignmentResponse): Promise<void> {
        if (personnelWeekdayAssignment) {
            await this._deletePersonnelWeekdayAssignment(personnelWeekdayAssignment.id)
            await this._loadPersonnelWeekdayAssignments()
        }
    }
}
